export default __webpack_public_path__ + "static/media/gallery1.2943bbb6.jpg";